import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types.tsx';

const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs
export const legacyGinIssueCloneRoute: InvariantRoute = {
	name: 'legacy-gin-issue-clone',
	path: `/(secure|issue)/CloneIssue(\\w*)${defaultSuffix}.jspa`,
};
